import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  CleanType,
  CleanTypeResponse,
  CleanTypeSingleResponse
} from 'Interfaces/ReferenceInterfaces/CleanTypeInterface';

export const cleanTypeScreenServices = {
  getAllCleanTypes: (page = 1, pageSize = 10000): Promise<CleanTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CleanTypeResponse>(
          `pps/clean-types?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCleanTypeById: (id: number): Promise<CleanTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CleanTypeSingleResponse>(`pps/clean-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createCleanType: (cleanTypeData: Partial<CleanType>): Promise<CleanTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<CleanTypeSingleResponse>(
          'pps/clean-types/',
          cleanTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateCleanType: (
    id: number,
    cleanTypeData: Partial<CleanType>
  ): Promise<CleanTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<CleanTypeSingleResponse>(
          `pps/clean-types/${id}/`,
          cleanTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteCleanType: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/clean-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
